import tippy from 'tippy.js';

if ($('.main.job-offers.detail').length > 0) {
    tippy('.tippy', {
        arrow: true,
        animation: 'fade',
        content:
            '主な確認事項<br>仕事日時、時給、交通費の有無、服装ルール<br>仕事内容、美容免許、スキル確認、持ち物<br>駐車場の有無',
        allowHTML: true,
    });
}
